export default __webpack_public_path__ + "static/media/logo.ee47eac2.png";